import { createHandlerChainRunner, Handler } from "@insite/client-framework/HandlerCreator";
import { MAX_ACCOUNT_NUMBER_LENGTH } from "@thkStore/Common/Constants/ShippingConstants";

type HandlerType = Handler<{ accountNumber: string }>;

export const DispatchSetAccountNumber: HandlerType = props => {
    const value = (props.parameter.accountNumber ?? "").slice(0, MAX_ACCOUNT_NUMBER_LENGTH);
    props.dispatch({
        type: "Shipping/SetAccountNumber",
        accountNumber: value,
    });
};

export const chain = [DispatchSetAccountNumber];

const setAccountNumber = createHandlerChainRunner(chain, "SetAccountNumber");
export default setAccountNumber;
